'use strict';
import $ = require('jquery');

export class recruitHero {
    constructor() {
        if ($('.bulletRecruitHero').length === 0) return;
        const time = 9000;
        let fadeTimer;

        line();
        window.addEventListener('resize',line);

        setTimeout(first, 500);
        setTimeout(fade_anime, 800);


        document.addEventListener('visibilitychange', () => {
            if (document.hidden) return;
            clearTimeout(fadeTimer);
            $('.bulletRecruitHeroItem').attr('data-is-active', 'false');
            fade_anime();
        });


        function first() {
            $('.bulletRecruitHeroTitle').attr('data-is-active', 'true');
            setTimeout(() => {
                $('.bulletRecruitHeroText').attr('data-is-active', 'true');
            }, 500);
        }

        function fade_anime() {
            clearTimeout(fadeTimer);
            const items = $('.bulletRecruitHeroItem');
            items.each(function (i) {
                const item = $(this);
                setTimeout(function () {
                    $('.bulletRecruitHeroItem').attr('data-is-active', 'false');
                    item.attr('data-is-active', 'true');
                }, i * time);
            });
            fadeTimer = setTimeout(fade_anime, items.length * time);
        }

//ラップトップレイアウト崩れ防止
        if (window.innerWidth > 1200 && window.innerHeight < 800) {
            $('.bulletRecruitHeroTitle').attr('data-laptop', 'true');
        }

        window.matchMedia('(min-width: 1200px)').addEventListener('change', (e) => {
            if (!e.matches) return;
            if (window.innerHeight < 800) {
                $('.bulletRecruitHeroTitle').attr('data-laptop', 'true');
            }
        });
// ラインの長さ取得
        function line() {
            const items = $('.bulletRecruitHeroLine');
            items.each(function (i, item) {
                const path = $(this).find('path')[0] as unknown as SVGPathElement;
                $(this).css('--length', `${path.getTotalLength()}px`);
            });
        }
    }
}

export default recruitHero;